// Add a secret: pick a template, then fill in its fields (AddSecretForm). Closing the
// drawer unmounts the form, so nothing typed outlives it.
import { useState } from "react";

import { useT } from "../i18n";
import { AddSecretForm } from "./AddSecretForm";
import type { Signer } from "./requests";
import { DrawerBody, DrawerHeader, SecretDrawer } from "./SecretDrawer";
import { type Credential, template, type TemplateId } from "./templates";
import { TemplatePicker } from "./TemplatePicker";

interface Props {
  open: boolean;
  /** Start on this template instead of the picker. */
  initial?: TemplateId;
  onClose: () => void;
  signer: Signer;
  signerName: string;
  orgId: string;
  onSaved: (credential: Credential) => void;
  onError: (message: string) => void;
}

export function AddSecretDrawer({ open, onClose, initial, ...form }: Props) {
  const copy = useT().secrets.forms.add;
  const [picked, setPicked] = useState<TemplateId | undefined>(initial);
  const t = picked && template(picked);
  const close = () => {
    setPicked(initial);
    onClose();
  };
  return (
    <SecretDrawer open={open} onClose={close}>
      <DrawerHeader title={t ? copy.newOf(t.label) : copy.title} onBack={t ? () => setPicked(undefined) : undefined} onClose={close} />
      {t ? (
        <AddSecretForm
          key={t.id}
          template={t}
          onCancel={close}
          {...form}
          onSaved={(c) => {
            close();
            form.onSaved(c);
          }}
        />
      ) : (
        <DrawerBody>
          <p className="text-[13px] text-gray-500">{copy.pick}</p>
          <TemplatePicker onPick={setPicked} />
        </DrawerBody>
      )}
    </SecretDrawer>
  );
}
